// based on this article: http://www.quirksmode.org/js/cookies.html
// manage cookies through javascript
// turned jquery plugin to avoid global namespace clutter

(function($){

  var cookieManager = $.cookieManager = {
    createCookie: function(name, value, days){

      var expires;

      if(days){
        var date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        expires = "; expires=" + date.toGMTString();

      }
      else {
        expires = "";
      }

      document.cookie = name + "=" + value + expires + "; path=/";

    },
    readCookie: function(name){

      var nameWithEquals = name + "=";

      var cookieArray = document.cookie.split(';');

      var currentCookie;

      for(var i = 0; i < cookieArray.length; i++){
        currentCookie = cookieArray[i];

        while(currentCookie.charAt(0) == ' '){
          currentCookie = currentCookie.substring(1, currentCookie.length);
        }

        if(currentCookie.indexOf(nameWithEquals) == 0){
          return currentCookie.substring(nameWithEquals.length, currentCookie.length);
        }
      }

      return null;

    },
    eraseCookie: function(name){
      cookieManager.createCookie(name,"",-1);
    }
  }

})(jQuery);
